enum AutomationsEnum {
  CreatorDetectionRunnableAutomation = "CreatorDetectionRunnableAutomation",
  PublicationDetectionRunnableAutomation = "PublicationDetectionRunnableAutomation",
  PublicationSynchronizationRunnableAutomation = "PublicationSynchronizationRunnableAutomation",
}

export default AutomationsEnum;
